import { render, staticRenderFns } from "./ReturnDetails.vue?vue&type=template&id=05c884fe&"
import script from "./ReturnDetails.vue?vue&type=script&lang=js&"
export * from "./ReturnDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDetails.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports